import script from "./WeChatSearchMsgWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatSearchMsgWindow.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatSearchMsgWindow.vue?vue&type=style&index=0&id=7896a696&lang=css"

const __exports__ = script;

export default __exports__